/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
import TableType from './TableType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/TableType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="tableType" type="{}tableType" minOccurs="0"/&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element ref="{}column" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}index" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}primaryKey" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}foreignKey" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="tableItem" type="{}tableItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Table extends PhysicalObjectType{

	tableType = null;

	numberOfRows = null;

	column = null;

	index = null;

	primaryKey = null;

	foreignKey = null;

	tableItem = null;



	/**
	 * Gets the value of the tableType property.
	 * @return {TableType} possible object is {@link TableType}
	 */
	getTableType() {
		return this.tableType;
	}

	/**
	 * Sets the value of the tableType property.
	 * @param {TableType} value allowed object is {@link TableType}
	 */
	setTableType(value) {
		var oldValue = this.tableType;
		this.tableType = value;
		this._setAndNotify(195, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the numberOfRows property.
	 * @return {Number} possible object is {@link Long}
	 */
	getNumberOfRows() {
		return this.numberOfRows;
	}

	/**
	 * Sets the value of the numberOfRows property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setNumberOfRows(value) {
		var oldValue = this.numberOfRows;
		this.numberOfRows = value;
		this._setAndNotify(61, oldValue, value, false, false);
	}

	/**
	 * Deprecated as of version 3.1, all columns should be under tableItems.Gets the value of the column property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the column property. <p> For example, to add a new item, do as follows: <pre> getColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Column}
	 */
	getColumn() {
		if (!this.column) {
			this.column = [];
		}
		return this.column;
	}

	/**
	 * Gets the value of the index property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the index property. <p> For example, to add a new item, do as follows: <pre> getIndex().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Index}
	 */
	getIndex() {
		if (!this.index) {
			this.index = [];
		}
		return this.index;
	}

	/**
	 * Gets the value of the primaryKey property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the primaryKey property. <p> For example, to add a new item, do as follows: <pre> getPrimaryKey().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PrimaryKey}
	 */
	getPrimaryKey() {
		if (!this.primaryKey) {
			this.primaryKey = [];
		}
		return this.primaryKey;
	}

	/**
	 * Gets the value of the foreignKey property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the foreignKey property. <p> For example, to add a new item, do as follows: <pre> getForeignKey().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ForeignKey}
	 */
	getForeignKey() {
		if (!this.foreignKey) {
			this.foreignKey = [];
		}
		return this.foreignKey;
	}

	/**
	 * Gets the value of the tableItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the tableItem property. <p> For example, to add a new item, do as follows: <pre> getTableItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TableItemType}
	 */
	getTableItem() {
		if (!this.tableItem) {
			this.tableItem = [];
		}
		return this.tableItem;
	}

	/**
	 * Gets the value of the <code>column</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Column</code> elements, or <code>null</code> if not set
	 */
	basicGetColumn() {
		return this.column;
	}

	/**
	 * Gets the value of the <code>index</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Index</code> elements, or <code>null</code> if not set
	 */
	basicGetIndex() {
		return this.index;
	}

	/**
	 * Gets the value of the <code>primaryKey</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>PrimaryKey</code> elements, or <code>null</code> if not set
	 */
	basicGetPrimaryKey() {
		return this.primaryKey;
	}

	/**
	 * Gets the value of the <code>foreignKey</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ForeignKey</code> elements, or <code>null</code> if not set
	 */
	basicGetForeignKey() {
		return this.foreignKey;
	}

	/**
	 * Gets the value of the <code>tableItem</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>TableItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetTableItem() {
		return this.tableItem;
	}

	/**
	 * Creates a new instance of <code>Table</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Table</code> object from.
	 * @return {Table} an object of type <code>Table</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTable();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addColumnAt(position, item) {
		this._addAtAndNotify(this.getColumn(), position, item, 196, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addColumn(item) {
		this.addColumnAt(this.getColumn().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeColumnAt(position) {
		this._removeAtAndNotify(this.getColumn(), position, 196, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeColumn(item) {
		var i = this.getColumn().indexOf(item);
		if (i >= 0) {
			this.removeColumnAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addIndexAt(position, item) {
		this._addAtAndNotify(this.getIndex(), position, item, 197, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addIndex(item) {
		this.addIndexAt(this.getIndex().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeIndexAt(position) {
		this._removeAtAndNotify(this.getIndex(), position, 197, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeIndex(item) {
		var i = this.getIndex().indexOf(item);
		if (i >= 0) {
			this.removeIndexAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPrimaryKeyAt(position, item) {
		this._addAtAndNotify(this.getPrimaryKey(), position, item, 199, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addPrimaryKey(item) {
		this.addPrimaryKeyAt(this.getPrimaryKey().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePrimaryKeyAt(position) {
		this._removeAtAndNotify(this.getPrimaryKey(), position, 199, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removePrimaryKey(item) {
		var i = this.getPrimaryKey().indexOf(item);
		if (i >= 0) {
			this.removePrimaryKeyAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addForeignKeyAt(position, item) {
		this._addAtAndNotify(this.getForeignKey(), position, item, 198, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addForeignKey(item) {
		this.addForeignKeyAt(this.getForeignKey().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeForeignKeyAt(position) {
		this._removeAtAndNotify(this.getForeignKey(), position, 198, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeForeignKey(item) {
		var i = this.getForeignKey().indexOf(item);
		if (i >= 0) {
			this.removeForeignKeyAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTableItemAt(position, item) {
		this._addAtAndNotify(this.getTableItem(), position, item, 165, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTableItem(item) {
		this.addTableItemAt(this.getTableItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTableItemAt(position) {
		this._removeAtAndNotify(this.getTableItem(), position, 165, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTableItem(item) {
		var i = this.getTableItem().indexOf(item);
		if (i >= 0) {
			this.removeTableItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Table";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 195, "tableType", TableType));
		featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
		var clazz;
		if (factory) {
			clazz = factory.createColumn().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 196, "column", clazz));
		if (factory) {
			clazz = factory.createIndex().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 197, "index", clazz));
		if (factory) {
			clazz = factory.createPrimaryKey().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 199, "primaryKey", clazz));
		if (factory) {
			clazz = factory.createForeignKey().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 198, "foreignKey", clazz));
		if (factory) {
			clazz = factory.createTableItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 165, "tableItem", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 195:
			this.setTableType((value));
			break;
		case 61:
			this.setNumberOfRows((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 165:
			this.tableItem = (value);
			break;
		case 196:
			this.column = (value);
			break;
		case 197:
			this.index = (value);
			break;
		case 198:
			this.foreignKey = (value);
			break;
		case 199:
			this.primaryKey = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 195:
			return this.getTableType();
		case 165:
			return this.getTableItem();
		case 196:
			return this.getColumn();
		case 197:
			return this.getIndex();
		case 61:
			return this.getNumberOfRows();
		case 198:
			return this.getForeignKey();
		case 199:
			return this.getPrimaryKey();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 195:
			return this.getTableType();
		case 165:
			return this.basicGetTableItem();
		case 196:
			return this.basicGetColumn();
		case 197:
			return this.basicGetIndex();
		case 61:
			return this.getNumberOfRows();
		case 198:
			return this.basicGetForeignKey();
		case 199:
			return this.basicGetPrimaryKey();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 165:
			this.addTableItemAt(position, (value));
			break;
		case 196:
			this.addColumnAt(position, (value));
			break;
		case 197:
			this.addIndexAt(position, (value));
			break;
		case 198:
			this.addForeignKeyAt(position, (value));
			break;
		case 199:
			this.addPrimaryKeyAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 165:
			this.addTableItem((value));
			break;
		case 196:
			this.addColumn((value));
			break;
		case 197:
			this.addIndex((value));
			break;
		case 198:
			this.addForeignKey((value));
			break;
		case 199:
			this.addPrimaryKey((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 165:
			this.removeTableItemAt(position);
			break;
		case 196:
			this.removeColumnAt(position);
			break;
		case 197:
			this.removeIndexAt(position);
			break;
		case 198:
			this.removeForeignKeyAt(position);
			break;
		case 199:
			this.removePrimaryKeyAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 165:
			this.removeTableItem((item));
			break;
		case 196:
			this.removeColumn((item));
			break;
		case 197:
			this.removeIndex((item));
			break;
		case 198:
			this.removeForeignKey((item));
			break;
		case 199:
			this.removePrimaryKey((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Table.js